import { UsersApi } from "@/Stub/V1";
import { BaseApiConfig } from "@/Service/Api/V1/BaseApiConfig";

export const UsersApiClient = new UsersApi(BaseApiConfig);